/* Cubitt Venezuela: precios en bolívares con la tasa BCV del checkout propio (/pages/checkout).
   Misma URL, misma caché (localStorage custom_checkout_bcv_rate_v2, 15 min) y mismo cálculo que el checkout
   ((dólares × tasa).toFixed(2)), para que el cliente vea la misma cifra que luego paga. Se escribe como en la ficha
   (metacampo custom.bs_price): "Bs. 154,526.59".
   - Carrito lateral: [data-cubitt-bs-total] (fila oculta hasta tener la tasa).
   - Tarjetas de producto, "Lo más visto"/"Cómpralo con" y la ficha: [data-cubitt-bs-price] (setting global "Precios
     en bolívares"); el hueco está reservado por CSS para que nada salte al llegar la tasa. En la ficha
     ([data-bs-variant]) sigue a la variante elegida y, mientras llega la tasa, se ve el metacampo de siempre.
   Una sola petición para toda la página (y ninguna mientras la caché siga vigente). Si la tasa no llega, no se
   muestra nada: precios, carrito y botones no dependen de esto. */
(() => {
  if (window.cubittBsPrices) return; // el carrito y el layout pueden cargar este archivo a la vez
  window.cubittBsPrices = true;

  const STORAGE_KEY = 'custom_checkout_bcv_rate_v2';
  const TTL = 15 * 60 * 1000;
  let ratePromise = null;
  let failedAt = 0; // tras un fallo, no se reintenta en 60 s (el carrito se repinta a menudo)

  const readCache = () => {
    try {
      const item = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (item && Date.now() <= item.expiry && Number(item.value) > 0) return Number(item.value);
    } catch (e) {}
    return null;
  };

  const writeCache = (rate) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: rate, expiry: Date.now() + TTL }));
    } catch (e) {}
  };

  const getRate = (url) => {
    const cached = readCache();
    if (cached) return Promise.resolve(cached);
    if (Date.now() - failedAt < 60000) return Promise.resolve(null);
    if (!ratePromise) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      ratePromise = fetch(url, { method: 'GET', cache: 'no-store', credentials: 'omit', signal: controller.signal })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const rate = Number(data && data.rate);
          if (rate > 0) { writeCache(rate); return rate; }
          failedAt = Date.now();
          return null;
        })
        .catch(() => { failedAt = Date.now(); return null; })
        .finally(() => { clearTimeout(timeout); ratePromise = null; });
    }
    return ratePromise;
  };

  const bs = (cents, rate) => `Bs. ${Number(((Number(cents) / 100) * rate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  let filling = false;
  const fill = async () => {
    const totals = document.querySelectorAll('[data-cubitt-bs-total][hidden]');
    const prices = document.querySelectorAll('[data-cubitt-bs-price]:not([data-bs-done])');
    if (!totals.length && !prices.length) return;
    const url = (totals[0] || prices[0]).dataset.rateUrl;
    if (!url || filling) return;
    filling = true;
    const rate = await getRate(url);
    filling = false;
    if (!rate) return;

    document.querySelectorAll('[data-cubitt-bs-total][hidden]').forEach((row) => {
      if (!(Number(row.dataset.cents) > 0)) return;
      const amount = row.querySelector('[data-cubitt-bs-amount]');
      if (amount) amount.textContent = bs(row.dataset.cents, rate);
      const note = row.querySelector('[data-cubitt-bs-rate]');
      if (note) note.textContent = (note.dataset.template || '').replace('[tasa]', String(rate));
      row.hidden = false;
    });

    document.querySelectorAll('[data-cubitt-bs-price]:not([data-bs-done])').forEach((el) => {
      if (Number(el.dataset.cents) > 0) el.textContent = (el.dataset.template || '[monto]').replace('[monto]', bs(el.dataset.cents, rate));
      el.setAttribute('data-bs-done', '');
    });
  };

  /* Las tarjetas llegan después (filtros, carruseles, carrito repintado, tarjeta-variante que cambia de precio):
     se agrupan los cambios en un solo repaso por fotograma y solo se trabaja si hay algo sin rellenar. */
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fill(); });
  };

  const start = () => {
    fill();
    new MutationObserver((mutations) => {
      let changed = false;
      for (const m of mutations) {
        if (m.type === 'attributes') { m.target.removeAttribute('data-bs-done'); changed = true; }
        else if (m.addedNodes.length) changed = true;
      }
      if (changed) queue();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cents'] });
  };

  /* Ficha: al cambiar de variante, el precio en bolívares sigue al precio de la variante. */
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    const scope = event.target.closest && event.target.closest('.shopify-section');
    if (!variant || !scope) return;
    scope.querySelectorAll('[data-cubitt-bs-price][data-bs-variant]').forEach((el) => el.setAttribute('data-cents', variant.price));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
